/**
 * Minimal replacement for the jQuery Chosen plugin: builds the same DOM
 * (.chosen-container-multi / -single, .chosen-choices, .chosen-drop, .chosen-results)
 * so the search-filter stylesheet applies, and keeps the <select> as the source of truth.
 */
export function chosen(select: HTMLSelectElement) {
  if (select.dataset.chosen) return
  select.dataset.chosen = '1'
  const multiple = select.multiple
  const placeholder = select.dataset.placeholder ?? (multiple ? 'Выберите' : select.options[0]?.text ?? '')
  const container = document.createElement('div')
  container.className = `chosen-container ${multiple ? 'chosen-container-multi' : 'chosen-container-single'}`
  container.id = `${select.id}_chosen`
  container.title = ''
  const drop = document.createElement('div')
  drop.className = 'chosen-drop'
  const results = document.createElement('ul')
  results.className = 'chosen-results'
  const input = document.createElement('input')
  input.type = 'text'
  input.className = 'chosen-search-input'
  input.autocomplete = 'off'

  let choices: HTMLUListElement | null = null
  let single: HTMLAnchorElement | null = null
  const field = document.createElement('li')
  if (multiple) {
    choices = document.createElement('ul')
    choices.className = 'chosen-choices'
    field.className = 'search-field'
    field.appendChild(input)
    drop.appendChild(results)
    container.append(choices, drop)
  } else {
    single = document.createElement('a')
    single.className = 'chosen-single'
    single.innerHTML = '<span></span><div><b></b></div>'
    const search = document.createElement('div')
    search.className = 'chosen-search'
    search.appendChild(input)
    drop.append(search, results)
    container.append(single, drop)
  }
  select.style.display = 'none'
  select.after(container)

  const filter = (q: string) => {
    results.innerHTML = ''
    const needle = q.toLowerCase().trim()
    let shown = 0
    Array.from(select.options).forEach((o) => {
      if (multiple && (o.selected || !o.value)) return
      if (needle && !o.text.toLowerCase().includes(needle)) return
      const li = document.createElement('li')
      li.className = `active-result${!multiple && o.selected ? ' result-selected' : ''}`
      li.dataset.optionArrayIndex = String(o.index)
      li.textContent = o.text
      results.appendChild(li)
      shown++
    })
    if (!shown) {
      const li = document.createElement('li')
      li.className = 'no-results'
      li.textContent = 'Нет результатов'
      results.appendChild(li)
    }
  }

  const render = () => {
    if (multiple && choices) {
      choices.innerHTML = ''
      Array.from(select.selectedOptions).forEach((o) => {
        const li = document.createElement('li')
        li.className = 'search-choice'
        li.innerHTML = `<span></span><a class="search-choice-close" data-option-array-index="${o.index}"></a>`
        li.querySelector('span')!.textContent = o.text
        choices!.appendChild(li)
      })
      choices.appendChild(field)
      const empty = !select.selectedOptions.length
      input.value = empty ? placeholder : ''
      input.classList.toggle('default', empty)
      input.style.width = empty ? '100%' : '25px'
    } else if (single) {
      const current = select.options[select.selectedIndex]
      single.querySelector('span')!.textContent = current?.text ?? placeholder
      single.classList.toggle('chosen-default', !current?.value)
    }
    filter('')
  }

  const open = () => {
    container.classList.add('chosen-with-drop', 'chosen-container-active')
    if (multiple && input.classList.contains('default')) {
      input.value = ''
      input.style.width = '100%'
    }
  }
  const close = () => {
    container.classList.remove('chosen-with-drop', 'chosen-container-active')
    render()
  }
  const choose = (index: number) => {
    if (multiple) select.options[index].selected = true
    else select.selectedIndex = index
    close()
    select.dispatchEvent(new Event('change'))
  }

  ;(choices ?? single)!.addEventListener('mousedown', (e) => {
    const x = (e.target as HTMLElement).closest<HTMLElement>('.search-choice-close')
    if (x) {
      e.preventDefault()
      select.options[Number(x.dataset.optionArrayIndex)].selected = false
      render()
      select.dispatchEvent(new Event('change'))
      return
    }
    e.preventDefault()
    if (container.classList.contains('chosen-with-drop') && !multiple) return close()
    open()
    window.setTimeout(() => input.focus())
  })
  results.addEventListener('mousedown', (e) => {
    const li = (e.target as HTMLElement).closest<HTMLElement>('.active-result')
    if (!li) return
    e.preventDefault()
    choose(Number(li.dataset.optionArrayIndex))
  })
  input.addEventListener('input', () => filter(input.value))
  input.addEventListener('blur', () => window.setTimeout(close, 150))
  render()
}
